import type { Translation } from "./types";

const ko: Translation = {
  home: {
    title: "오마이플레이 스코어보드",
    subtitle: "Scoreboard",
    loginButton: "로그인",
    gymSelectionButton: "체육관 선택",
  },
  gameSelection: {
    searchButtonTitle: "검색",
    disqualifiedFailedMessage: "기권 처리에 실패하였습니다. 대회 운영 본부 혹은 기술지원팀에 문의하세요.",
    disqualifiedSuccessMessage: "기권 처리가 완료되었습니다.",
    umpireSaveFailedMessage: "심판 저장에 실패하였습니다. 다시 한 번 시도해보시고, 문제가 지속되면 대회 운영 본부 혹은 기술지원팀에 문의하세요.",
    ofTeam: "팀의",
    startGameSuccessTitle: "경기 시작",
    startGameSuccessDescription: "경기가 시작되었습니다.",
    startGameSuccessActionText: "확인",
    playerCallSuccessTitle: "선수 호출 ",
    playerCallSuccessDescription: "선수 호출이 되었습니다.",
    playerCallSuccessActionText: "확인",
    noPlayerAlertTitle: "선수 정보 없음",
    noPlayerAlertDescription: "선수 정보를 불러올 수 없습니다. 경기 번호와 경기 타입을 다시 확인 해보시고, 오류가 지속될 경우 관리자에게 문의해주세요.",
    noPlayerAlertActionText: "확인",
    noPlayerAlertCancelText: "취소",
    noPlayerAlertConfirmText: "확인",
    disqualifiedSuccessTitle: "기권 처리 완료",
    disqualifiedSuccessActionText: "확인",
    errorTitle: "오류",
    errorDescription: "오류가 발생하였습니다. 다시 시도해보시고, 문제가 지속되면 대회 운영 본부 혹은 기술지원팀에 문의해주세요.",
    errorActionText: "확인",
    noMatchTitle: "경기 없음",
    noMatchDescription: "해당 순서에 경기가 없습니다.",
    noMatchActionText: "확인",
    noUmpireAlertTitle: "심판 정보 없음",
    noUmpireAlertDescription: "주심을 선택하거나 입력해주세요.",
    noUmpireAlertActionText: "확인",
    noUmpireAlertCancelText: "취소",
    courtTitle: "코트",
    court: "코트",
    match: "번 경기",
    loadMatchTitle: "경기 불러오기",
    byOrder: "코트 순서",
    byTimetable: "시간표",
    byNumber: "번호 직접 입력",
    byMatchNumber: "경기 번호",
    byOrderDescription: "이 코트에서 진행되는 경기를 선택할 수 있습니다.",
    byTimetableDescription: "다른 코트의 예정된 경기를 경기를 선택할 수 있습니다.",
    byNumberDescription: "경기 번호를 입력하여 경기를 선택할 수 있습니다.",
    byMatchNumberDescription: "전체 경기를 경기번호 순으로 확인할 수 있습니다.",
    searchMatchCheckboxTitle: "완료된 경기 포함 검색",
    searchMatchButtonTitle: "경기 검색",
    previousMatchButtonTitle: "이전 경기",
    nextMatchButtonTitle: "다음 경기",
    noMatchSearchMatchGuide: "경기 검색 버튼을 눌러 경기를 찾아보세요.",
    timetableSearchMatchGuide: "다른 코트에서 진행예정인 경기도 경기 진행할 수 있습니다.",
    matchListTitle: "경기 목록",
    matchListLoading: "경기 목록을 불러오는 중...",
    matchNumberTitle: "경기번호",
    personalMatchTitle: "개인전",
    teamMatchTitle: "단체전",
    goToMatchButtonTitle: "경기 진행",
    teamMatchOrderTitle: "단체전 경기순서",
    checkMatchandPlayerTitle: "경기 및 선수 확인",
    backButtonTitle: "뒤로 가기", 
    viewSubMatchButtonTitle: "세부 경기 조회",
    umpireInputDescription: "심판을 선택하거나, 목록에 없으면 직접 입력해주세요.",
    umpireInputPlaceholder: "심판 선택",
    umpireInputDirection: "심판 이름 직접 입력",
    umpire: "심판",
    umpireSaveButtonTitle: "심판 저장",
    umpireErrorMessage: "심판을 등록해주세요. 심판을 등록해야 경기를 시작할 수 있습니다.",
    GotoSettingButtonTitle: "경기 확인 완료",
    notReadyPlayerWalkoutButtonTitle: "입장하지 않은 선수 기권 처리",
    walkoverTitle: "기권 처리",
    walkoverBothTeamTitle: "양 팀 모두 기권 처리하시겠습니까?",
    walkoverDescription: "기권 처리하시겠습니까?",
    walkoverActionText: "기권 처리",
    walkoverCancelText: "취소",
    playerCheckDescription: "입장한 선수를 터치해주세요.",
    playerCallTitle: "선수 호출",
    playerCallDescription: "선수를 호출하시겠습니까?",
    playerCallActionText: "확인",
    playerCallCancelText: "취소",
    playerReadyButton: "선수 준비 완료",
    playerCallLoading: "호출 중...",
    playerCallButtonTitle: "선수 호출",
  },
  matchSettingDialog: {
    title: "경기 설정",
    numOfSetsTitle: "세트 수",
    pointsPerSetTitle: "세트 점수",
    numOfSetsDescription: "이 경기의 Game 수를 설정합니다.",
    pointsPerSetDescription: "이 경기의 Game 점수를 설정합니다.",
  },
  gameStart: {
    gameStartTitle: "자리 설정",
    warmUpCompleteButtonTitle: " 완료",
    warmUpBackButtonTitle: " 돌아가기",
    stopButtonTitle: "정지",
    startButtonTitle: "시작",
    startGameButtonTitle: "이 팀을 서버로 경기 시작",
    colorSelectTitle: "색상 선택",
    selectedColor: "선택된 색상",
    orderTitle: "순서",
    positionTitle: "위치",
  },
  gamePlay: {
    gamePlayTitle: "경기 진행",
    undoButtonTitle: "UNDO",
    matchEndTitle: "GAME",
    gameEndTitle: "GAME",
    conductGameTitle: "Conduct Game 처리됩니다.",
    conductMatchTitle: "Conduct Match 처리됩니다.",
    disqualifiedTitle: "Disqualified 처리됩니다.",
    retiredTitle: "Retired 처리됩니다.",
    walkoverTitle: "으로 기권 처리됩니다.",
    matchEndDescription: "이 경기가 완전히 종료됩니다. 계속하시겠습니까?",
    gameEndDescription: "현재 게임이 종료되고 다음 게임이 진행됩니다. 계속하시겠습니까?",
    matchEndButtonTitle: "Match End",
    gameEndButtonTitle: "Game End",
    nextGameButtonTitle: "NEXT GAME",
    errorTitle: "오류",
    errorDescription: "오류가 발생하였습니다. 다시 시도해보시고, 문제가 지속되면 대회 운영 본부 혹은 기술지원팀에 문의해주세요.",
    errorActionText: "확인",
    positionChangeTitle: "자리 설정 변경",
    winnerTeam: "승리팀",
    loserTeam: "패배팀",
    positionChangeDescription: "자리 설정을 변경하시겠습니까?",
    positionChangeActionText: "변경",
  },
  gamePlayButtonGroup: {
    injuryTimeTitle: "부상 시간",
    injuryTimeResumeButtonTitle: "재개",
    injuryTimePauseButtonTitle: "일시정지",
    injuryTimeResetButtonTitle: "초기화",
    misconductDescription: "아래 버튼을 눌러 Misconduct를 기록하세요.",
  },
  navigationBar: {
    callOperatorButtonTitle: "OMP 지원요청",
    callOperatorSuccessTitle: "호출 성공",
    callOperatorSuccessDescription: "진행석 호출에 성공하였습니다. 잠시만 기다려주세요.",
    callOperatorSuccessActionText: "확인",
  },
  gymSelection: {
    gymSelectionTitle: "경기장 선택",
    selectDateTitle: "날짜",
    tournametDateTitle: "대회 날짜",
    selectGymTitle: "경기장 입장",
  },
  courtSelection: {
    courtSelectionTitle: "코트 선택",
    courtSelectionInfo: "코트를 선택하여 경기를 진행할 코트 입장하세요.",
    courtTitle: "코트",
    umpireButtonTitle: "심판 입장",
    scoreViewButtonTitle: "점수 보기",
    liveScoreButtonTitle: "전체 라이브스코어",
    scoreboardDisplayButtonTitle: "전광판용",
  },
  navigation: {
    kr: "한국어",
    es: "스페인어",
    en: "영어",
  },
  days: ["일", "월", "화", "수", "목", "금", "토"],
};

export default ko;
